<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    
    <section>
      <ValidationObserver 
        ref="form">
        <v-form>
          <div 
            class="title font-weight-bold black--text mb-6"
            style="opacity: 70%;">
            #Lainnya Sentana
          </div>

          <v-row
            style="min-height: 64.6vh;">
            <v-col 
              cols="12" 
              md="6"
              class="py-0">
              <ValidationProvider 
                name="norek_danais" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  No. Rekening Danais
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 50}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. 3910XXXXX"
                  hide-details
                  clearable
                  @click:clear="form.norek_danais = ''"

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"

                  v-uppercase

                  v-model="form.norek_danais"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        No. Rekening Danais {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.norek_danais !== '' && valid && form.norek_danais !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <div>
                <div class="body-2 mb-2">
                  Tanggal Awal Terima Danais
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-menu
                  ref="tgl_awal_terima_danais"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.tgl_awal_terima_danais">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="tgl_awal_terima_danais" 
                      v-slot="{ errors, valid }">
                      <v-text-field
                        :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                        class="mb-6"
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="2023-01-01"
                        hide-details
                        clearable
                        @click:clear="form.tgl_awal_terima_danais = ''"

                        v-uppercase

                        v-model="form.tgl_awal_terima_danais"
                        v-on="on"
                        v-bind="attrs"
                        :success="form.tgl_awal_terima_danais !== '' && valid"
                        :error-messages="errors"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tanggal Awal Terima Danais {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.tgl_awal_terima_danais !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="form.tgl_awal_terima_danais"
                    @input="picker.tgl_awal_terima_danais = false">
                  </v-date-picker>
                </v-menu>
              </div>

              <div>
                <div class="body-2 mb-2">
                  Tanggal Bergabung Koperasi
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-menu
                  ref="kop_join_date"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.kop_join_date">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="kop_join_date" 
                      v-slot="{ errors, valid }">
                      <v-text-field
                        :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                        class="mb-6"
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="2023-01-01"
                        hide-details
                        clearable
                        @click:clear="form.kop_join_date = ''"

                        v-uppercase

                        v-model="form.kop_join_date"
                        v-on="on"
                        v-bind="attrs"
                        :success="form.kop_join_date !== '' && valid"
                        :error-messages="errors"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tanggal Lahir {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.kop_join_date !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="form.kop_join_date"
                    @input="picker.kop_join_date = false">
                  </v-date-picker>
                </v-menu>
              </div>

              <ValidationProvider 
                name="bpjs_jenis" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Jenis BPJS
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 45}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. Kelas 1"
                  hide-details
                  clearable
                  @click:clear="form.bpjs_jenis = ''"

                  v-uppercase

                  v-model="form.bpjs_jenis"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Jenis BPJS {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.bpjs_jenis !== '' && valid && form.bpjs_jenis !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <!-- <ValidationProvider 
                name="job_other" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Pekerjaan Selain Abdi Dalem
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. Manager F&B"
                  hide-details

                  v-uppercase

                  v-model="form.job_other"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Pekerjaan Selain Abdi Dalem {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.job_other !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider> -->

              <ValidationProvider 
                name="asuransi_kes" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Memiliki Asuransi Kesehatan dan/atau Ketenagakerjaan
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-select
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. YA"
                  hide-details
                  clearable
                  @click:clear="form.asuransi_kes = ''"
                  
                  :items="['YA', 'TIDAK', 'BELUM DIINPUT']"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.asuransi_kes"
                  :success="form.asuransi_kes !== '' && valid"
                  :error-messages="errors"
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Memiliki Asuransi Kesehatan dan/atau Ketenagakerjaan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.asuransi_kes !== '' && valid && form.asuransi_kes !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <ValidationProvider 
                name="nomor_polis_asuransi" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Nomor Polis Asuransi
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 50}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. 492010XXXXX"
                  hide-details
                  clearable
                  @click:clear="form.nomor_polis_asuransi = ''"

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"

                  v-uppercase

                  v-model="form.nomor_polis_asuransi"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nomor Polis Asuransi {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.nomor_polis_asuransi !== '' && valid && form.nomor_polis_asuransi !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="asuransi_status" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Status Asuransi
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-select
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. MANDIRI"
                  hide-details
                  clearable
                  @click:clear="form.asuransi_status = ''"
                  
                  :items="['MANDIRI', 'PAKUALAMAN', 'BELUM DIINPUT']"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.asuransi_status"
                  :success="form.asuransi_status !== '' && valid"
                  :error-messages="errors"
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Status Asuransi {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.asuransi_status !== '' && valid && form.asuransi_status !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <!-- <ValidationProvider 
                name="catatan_kesehatan" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Catatan Kesehatan
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>
                
                <v-textarea
                  v-on:keyup.enter="save"
                  style="border-radius: 10px;"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  rows="3"

                  :color="set_color"
                  placeholder="Contoh. Tuliskan catatan disini . . ."
                  
                  v-uppercase

                  v-model="form.catatan_kesehatan"
                  :success="form.catatan_kesehatan !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Catatan Kesehatan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.catatan_kesehatan !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-textarea>
              </ValidationProvider> -->
            </v-col>
          </v-row>
        </v-form>

        <div v-if="message.error.length > 0"
          class="text-center my-4">
          <div
            class="error--text d-flex align-center">
            <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>
      </ValidationObserver>

      <div>
        <v-divider 
          class="mb-4" 
          style="border: 3px solid #f0f0f0; border-radius: 50px;"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()"
            color="green"
            elevation="0"
            class="body-2 font-weight-bold white--text text-capitalize"
            style="border-radius: 10px;">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>

            Simpan
          </v-btn>

          <router-link
            to="/sentana">
            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text px-2 ml-2"
              :disabled="process.form"
              style="border-radius: 10px;">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>

              Batal
            </v-btn>
          </router-link>
        </v-card-actions>
      </div>
    </section>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        dialog: {
          snackbar: false
        },
        picker: {
          tgl_awal_terima_danais: null,
          kop_join_date: null
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      }
    },
    mounted () {

    },
    methods: {
      async save () {
        this.message.error = ''
        
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          let forms = Object.assign({}, this.form)
          forms.seksi = JSON.stringify(forms.seksi)
          
          await post(`admin/user/update`, {
            data: forms
          })
          .then((response) => {
            let res = response.data

            if (res.status === 200) {
              this.$emit('load', true)
                
              this.process.form = false

              this.dialog.snackbar = true
              this.message.success = res.message
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>